import { render, staticRenderFns } from "./AccessGroupList.vue?vue&type=template&id=424039cd&"
import script from "./AccessGroupList.vue?vue&type=script&lang=js&"
export * from "./AccessGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports